import React from 'react'
import { Sidebar } from 'web/components/shared/Sidebar'
import { CreateRosterPlayerSidebar } from './CreateRosterPlayerSidebar'
import { ScrollableContainer } from 'web/components/generic/ScrollableContainer'
import { EditRosterContainer } from './EditRosterContainer'

export const EditRosterMode: React.FC = () => {
    return (
        <>
            <Sidebar>
                <CreateRosterPlayerSidebar />
            </Sidebar>

            <ScrollableContainer>
                <EditRosterContainer />
            </ScrollableContainer>
        </>
    )
}
